import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';

const bannerData = [
  {
    id: 1,
    title: '伪装学渣',
    subtitle: '年度最受欢迎校园漫画',
    description: '学霸与学渣的身份互换，青春的懵懂与悸动',
    link: '/comic/1',
    bgImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20manhua%20style%20illustration%20of%20two%20high%20school%20students%20in%20a%20classroom%2C%20warm%20sunlight%20streaming%20through%20windows%2C%20soft%20pastel%20colors%2C%20dreamy%20atmosphere%2C%20cherry%20blossoms%20outside%2C%20anime%20aesthetic%2C%20clean%20and%20artistic%20composition%2C%20professional%20manga%20illustration&width=1600&height=900&seq=hero-banner-01&orientation=landscape',
  },
  {
    id: 2,
    title: '一人之下',
    subtitle: '国漫巅峰之作',
    description: '异人世界的冒险，揭露隐藏在现代都市下的神秘力量',
    link: '/comic/4',
    bgImage: 'https://readdy.ai/api/search-image?query=An%20epic%20Chinese%20manhua%20style%20illustration%20of%20martial%20artists%20with%20supernatural%20powers%2C%20dramatic%20energy%20effects%2C%20urban%20fantasy%20setting%2C%20dynamic%20composition%2C%20cool%20atmospheric%20tones%2C%20professional%20manga%20art%2C%20stunning%20visual%20impact&width=1600&height=900&seq=hero-banner-02&orientation=landscape',
  },
  {
    id: 3,
    title: '天官赐福',
    subtitle: '古风奇幻仙侠大作',
    description: '八百年轮回，花城与谢怜的千古绝恋',
    link: '/comic/5',
    bgImage: 'https://readdy.ai/api/search-image?query=A%20breathtaking%20Chinese%20manhua%20style%20illustration%20of%20celestial%20beings%20in%20ancient%20Chinese%20fantasy%20world%2C%20floating%20palaces%2C%20drifting%20flower%20petals%2C%20ethereal%20lighting%2C%20elegant%20artistic%20composition%2C%20beautiful%20manga%20artwork&width=1600&height=900&seq=hero-banner-03&orientation=landscape',
  },
];

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  const nextSlide = useCallback(() => {
    setCurrent((prev) => (prev + 1) % bannerData.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, [nextSlide]);

  return (
    <section className="relative h-[480px] md:h-[580px] w-full overflow-hidden">
      {bannerData.map((banner, idx) => (
        <div
          key={banner.id}
          className="absolute inset-0 bg-cover bg-center transition-opacity duration-700"
          style={{
            backgroundImage: `url(${banner.bgImage})`,
            opacity: idx === current ? 1 : 0,
          }}
        />
      ))}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
      <div className="relative z-10 h-full flex items-center">
        <div className="max-w-7xl mx-auto px-4 md:px-6 w-full">
          <div className="max-w-xl">
            <p className="text-white/80 text-sm md:text-base font-medium mb-2 whitespace-nowrap">
              {bannerData[current].subtitle}
            </p>
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-4 whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>
              {bannerData[current].title}
            </h2>
            <p className="text-white/70 text-sm md:text-base leading-relaxed mb-6 line-clamp-2">
              {bannerData[current].description}
            </p>
            <Link
              to={bannerData[current].link}
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white px-6 py-3 rounded-full text-sm font-semibold transition-colors whitespace-nowrap"
            >
              立即阅读 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 flex items-center gap-2">
        {bannerData.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrent(idx)}
            className={`rounded-full transition-all duration-300 ${
              idx === current ? 'bg-white w-6 h-2' : 'bg-white/50 w-2 h-2'
            }`}
            aria-label={`切换到第${idx + 1}张`}
          />
        ))}
      </div>
    </section>
  );
}